import React from "react";
import { motion } from "framer-motion";

const milestones = [
  { year: "2019", title: "Company Founded", desc: "SYR Mediaworks incorporated with a vision to make performance marketing measurable and honest." },
  { year: "2020", title: "Internal Buying Expansion", desc: "Scaled internal media buying teams across paid social, search and app installs." },
  { year: "2021", title: "Affiliate Partnerships", desc: "Onboarded 100+ publishers and launched CPA / CPL / CPI performance stacks." },
  { year: "2022", title: "National Campaigns", desc: "Executed national-scale campaigns for FinTech, Insurance and Gaming leaders." },
  { year: "2024", title: "Enterprise Growth", desc: "Enterprise reporting, AI automation and custom software for large brands & Govt." },
  { year: "2026", title: "Scaling India & Beyond", desc: "Expanding globally with AI-powered growth solutions for ambitious businesses." },
];

export default function Journey() {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="aurora bg-[#C9A227] w-[420px] h-[420px] top-0 -left-40" style={{opacity:0.15}} />
      <div className="aurora bg-[#047857] w-[420px] h-[420px] bottom-0 -right-40" style={{opacity:0.14}} />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="text-center max-w-3xl mx-auto">
          <span className="eyebrow">Our Journey</span>
          <h2 className="mt-6 text-4xl md:text-6xl font-semibold">
            Building today for a <span className="text-gold-gradient">stronger tomorrow.</span>
          </h2>
          <p className="mt-6 text-white/60 text-lg">From a bold idea to a nationally recognized DPIIT startup empowering Bharat.</p>
        </div>

        <div className="mt-20 relative">
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#C9A227]/60 to-transparent -translate-x-1/2" />
          <div className="space-y-10 md:space-y-16">
            {milestones.map((m, i) => {
              const left = i % 2 === 0;
              return (
                <motion.div
                  key={m.year}
                  initial={{opacity:0, y:30}}
                  whileInView={{opacity:1, y:0}}
                  viewport={{once:true}}
                  transition={{duration:0.7, ease:[0.16,1,0.3,1]}}
                  className={`grid md:grid-cols-2 gap-6 items-center ${left ? "" : "md:[direction:rtl]"}`}
                >
                  <div className={`glass rounded-3xl p-8 card-lift ${left ? "md:mr-6" : "md:ml-6 [direction:ltr]"}`}>
                    <div className="text-5xl font-semibold text-gold-gradient">{m.year}</div>
                    <div className="mt-4 text-xl font-semibold">{m.title}</div>
                    <p className="mt-3 text-white/60 leading-relaxed">{m.desc}</p>
                  </div>
                  <div className="hidden md:flex items-center justify-center [direction:ltr]">
                    <div className="w-4 h-4 rounded-full bg-[#C9A227] shadow-[0_0_24px_#C9A227]" />
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
